<template>
  <div class="signin container box">
    <h2>電話番号を入力してください</h2>
    <p class="note">
      セキュリティ強化と不正防止のため、電話番号認証によるログインをお願いしています。SMS(ショートメッセージ)が受けとれる日本の電話番号を下のフォームに入力してください。
    </p>
    <tel @finishAuth="finishSignin" />
    <!--<twitter @finishAuth="finishSignin" />-->
  </div>
</template>

<script>
import tel from './Auth/tel'
import twitter from './Auth/twitter'

export default {
  name: 'Signin',
  components: {
    tel,
    twitter
  },
  data: function () {
    return {
    }
  },
  methods: {
    finishSignin: function () {
      this.$router.push('/main')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.signin {
  margin-top: 20px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center
}
h2{
  font-size: 27px;
  margin: 0;
}
.note{
  font-size: 20px;
  color: #999;
}
@media all and (max-width: 480px) {
  h2{
    font-size: 20px;
  }
  .note{
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Sign.vue